module.exports = __webpack_public_path__ + "img/clipboard-list.b55a6c70.svg";